export const LEAD_INFO_MOCK = {
  id: '5b056578-4227-4bba-b266-d4a7b99167f0',
  email: 'teste1701231@olist.com',
  signup_url: 'https://app.olist.com/setup/pre-signup',
  name: 'teste1701231@olist.com',
  phone: '+5522222222222',
  document_number: '88306644000153',
};

export const CATEGORIES_MOCK = [
  { is_valid: true, key: 'acessorios_fashion', label: 'Acessórios Fashion' },
  { is_valid: true, key: 'acessorios_automotivos', label: 'Acessórios Automotivos' },
  {
    is_valid: true,
    key: 'alimentos_industrializados',
    label: 'Alimentos Industrializados',
  },
  { is_valid: false, key: 'alimentos_pereciveis', label: 'Alimentos Perecíveis' },
  { is_valid: true, key: 'artesanatos', label: 'Artesanatos' },
  { is_valid: true, key: 'bebidas', label: 'Bebidas' },
  { is_valid: true, key: 'bolsas_e_mochilas', label: 'Bolsas e Mochilas' },
  { is_valid: true, key: 'brinquedos_e_games', label: 'Brinquedos e Games' },
  { is_valid: false, key: 'calcados', label: 'Calçados' },
  { is_valid: true, key: 'casa_e_decoracao', label: 'Casa e Decoração' },
  { is_valid: true, key: 'construcao_e_ferramentas', label: 'Construção e Ferramentas' },
  {
    is_valid: true,
    key: 'cosmeticos_e_perfumaria_saude',
    label: 'Cosméticos e Perfumaria/Saúde',
  },
  { is_valid: true, key: 'eletronicos', label: 'Eletrônicos' },
  { is_valid: true, key: 'eletroportateis', label: 'Eletroportáteis' },
  { is_valid: true, key: 'esporte_e_lazer', label: 'Esporte e Lazer' },
  { is_valid: true, key: 'festas', label: 'Festas' },
  { is_valid: false, key: 'flores_e_plantas', label: 'Flores e Plantas' },
  { is_valid: true, key: 'informatica', label: 'Informática' },
  { is_valid: true, key: 'instrumento_musical', label: 'Instrumento Musical' },
  { is_valid: true, key: 'insumos', label: 'Insumos' },
  { is_valid: true, key: 'joia_e_bijuteria', label: 'Joia e Bijuteria' },
  { is_valid: true, key: 'livros', label: 'Livros' },
  { is_valid: false, key: 'marketing_multinivel', label: 'Marketing Multinível' },
  { is_valid: true, key: 'moveis_para_casa', label: 'Móveis para casa' },
  { is_valid: true, key: 'moveis_para_escritorio', label: 'Móveis para escritório' },
  { is_valid: true, key: 'oculos', label: 'Óculos' },
  { is_valid: true, key: 'papelaria', label: 'Papelaria' },
  { is_valid: true, key: 'pet_shop', label: 'Pet Shop' },
  { is_valid: true, key: 'presentes', label: 'Presentes' },
  { is_valid: true, key: 'religioso', label: 'Religioso' },
  { is_valid: true, key: 'relogios', label: 'Relógios' },
  { is_valid: false, key: 'roupas', label: 'Roupas' },
  { is_valid: false, key: 'servicos', label: 'Serviços' },
  { is_valid: true, key: 'suplementos', label: 'Suplementos' },
  { is_valid: true, key: 'telefonia_celulares', label: 'Telefonia/Celulares' },
  { is_valid: false, key: 'outros', label: 'Outros' },
  { is_valid: false, key: 'sem_empresa_formalizada', label: 'Sem empresa formalizada' },
  { is_valid: true, key: 'sex_shop', label: 'Sex Shop' },
];

export const MOCK_REVENUES = {
  count: 8,
  next: null,
  previous: null,
  results: [
    { id: '95f4dace-f172-417b-9340-b2102a09fabf', region: 'br', range: 'até 7000' },
    { id: 'd12a1ce8-f3f9-4cd4-92c6-2f42aa4f054a', region: 'br', range: '7.000 a 29.999' },
    { id: 'f1b7b525-13a4-4a72-9a32-3f5032af4569', region: 'br', range: '30.000 a 99.999' },
    { id: '7589b966-7a52-4137-aed3-f170e2592721', region: 'br', range: '100.000 a 199.999' },
    { id: 'ef6ad78f-a111-4693-8779-855d24a363ef', region: 'br', range: '200.000 a 2.9 milhões' },
    { id: '780b5dd9-3ffa-498f-9a70-82754ae7edc0', region: 'br', range: '3 milhões a 24.9 milhões' },
    { id: '369546fc-a40b-4635-a7d6-189bd20c92d9', region: 'br', range: 'mais que 25 milhões' },
    { id: '4035fa39-1bd4-4d30-9c5b-c307cd0bc124', region: 'br', range: 'prefiro não informar' },
  ],
};

export const INTERGRATORS_MOCK = {
  integrators: [
    { label: 'tiny', value: '551d9c26-d865-4684-b8d9-c383450628a4' },
    { label: 'tagplus', value: 'ed908cf1-cdad-4672-a408-f733d1e08fb3' },
    { label: 'vhsys', value: 'cca9a207-0100-44a0-afd8-1e71f6a26201' },
    { label: 'dslite', value: '1b0be1dc-d20b-49a1-a700-1f0ead1f464e' },
    { label: 'fdcsistemas', value: '5e0e59c9-ddf4-40c2-b924-467471efa6cb' },
    { label: 'ambarx', value: '45f0112c-9285-495a-8356-e97dc9e4b652' },
    { label: 'alternativa sistemas', value: '20cf75bb-cf81-4dc3-832a-861ca74578ef' },
    { label: 'marcosistem', value: '76266067-f45c-48a8-a152-1bfbb6d5cdf2' },
    { label: 'softop sistemas', value: '50d4910b-4253-45d0-95fa-c8baf30c0091' },
    { label: 'openmanager', value: 'f72325f4-549b-4b0e-81b7-335a129281ad' },
    { label: 'cssistemas', value: '537f3e21-e441-4144-8913-eb79ffde27b6' },
    { label: 'tsolucoes', value: '9f1070d3-5d38-4b81-82b9-2c7ecf015eee' },
    { label: 'poligono', value: 'ea6b9723-50d8-43f1-a212-e9eb152ede0d' },
    { label: 'gestor sistemas', value: 'b994f125-c011-4470-b63c-c64218fce81e' },
    { label: 'adsomos', value: 'c3e4f041-b380-4bf9-8bc1-a76f7be48cd4' },
    { label: 'precode', value: 'e908d1d5-d6c6-4118-878e-48cd6ec76572' },
    { label: 'omie / mintegra', value: '48ab109f-84ac-4efa-b9a2-59db3e08050a' },
    { label: 'bling', value: '7c7bdf51-0b28-403c-b371-fb5fbdfb53dc' },
    { label: 'vtex', value: '483fa7b6-45cc-4643-b63f-5c4ddcf9ad2c' },
    { label: 'f1 commerce', value: '9b9b18f2-3a07-4ac5-9e20-cb056226f66b' },
    { label: 'cosis commerce', value: '06dced84-bc4f-48e4-bb1b-ce0fe578e127' },
    { label: 'rp commerce', value: '77c935b7-19ac-42de-aa94-cc4ac7e6b951' },
    { label: 'visual e-commerce', value: 'aa93f09c-875a-42bb-a46d-c74f76d6bcff' },
    { label: 'wap.connect', value: '89cc9693-6a73-4018-9895-0e167e47a2f5' },
    { label: 'commerce plus', value: 'd5b09a76-549f-4f5a-b958-5062a34c4a78' },
    { label: 'all integra', value: 'cce45742-ce8d-47ae-a1c7-bd8d109f9a4d' },
    { label: 'web4business', value: 'b4174cf0-366e-4bd9-a205-5ddde04e657d' },
    { label: 'magic 5', value: 'cc061eb4-e7ab-40c0-a360-a3b7800381bd' },
    { label: 'shopping de preços', value: '8aceac96-35be-447b-9008-46bf7e171ee6' },
    { label: 'b4 Commerce', value: 'a2144593-42a3-4dc5-9d72-b948868ae727' },
    { label: 'estoca', value: '690e6a60-cf50-4327-8623-b3db8dd5c8cb' },
    { label: 'omnione', value: '4c272263-0db3-4480-9723-2a632fc04d7a' },
    { label: 'ideris', value: '02de4766-2c71-499e-922a-6868b17b2989' },
    { label: 'tray', value: '8314ac45-3f70-4df4-971d-09b291797246' },
    { label: 'magazord', value: '6293e662-5b85-4b43-a339-f3f6660c93dc' },
    { label: 'gvm soluções', value: '88ff0841-4355-4919-8641-085669ca1a3d' },
    { label: 'outros', value: '04eecd69-242f-4487-a27b-b09f49578f5e' },
    { label: 'não utilizo integrador', value: 'f73b7877-a35a-49c8-af17-defcd4138d94' },
  ],
};

export const MOCK_FULL_LEAD = {
  user: {
    id: '5eb934a0-50f2-4ec2-8b1e-572ba979361e',
    name: 'teste199@olist.com',
    email: 'teste199@olist.com',
    phone: '5511111111111',
    documentNumber: null,
  },
  leads: [
    {
      id: '867c92fd-6dec-41dc-b708-cf7ecb194d06',
      company: {
        id: 'b6b9a72a-8c9c-4c17-9dc7-560241f74999',
        documentNumber: '07047386000136',
        createdAt: '2022-07-29T13:18:28.732235Z',
        updatedAt: '2022-08-03T13:24:45.663472Z',
        companyName: null,
      },
      user: {
        id: '5eb934a0-50f2-4ec2-8b1e-572ba979361e',
        name: 'teste199@olist.com',
        email: 'teste199@olist.com',
        phone: '5511111111111',
        documentNumber: null,
      },
      mainCategoryId: 'fa2d680f-4449-48e4-86fe-0025881d2e4a',
      region: 'br',
    },
  ],
  leadAttributes: [
    {
      id: '5144d67f-7c99-4c9a-abae-2f030eff80c3',
      leadId: '867c92fd-6dec-41dc-b708-cf7ecb194d06',
      product: 'store',
      attributeId: '533329c9-b811-4a20-858c-42cb2361d447',
      attributeName: 'Tags',
      attributeSlug: 'rdstation_tags',
      value:
        "['optin-legal-base', 'percorrendo fluxo - self store | data account', 'percorrendo fluxo - self store | bank account', 'percorrendo fluxo - self store | qualification', 'percorrendo fluxo - self store | checkout', 'rd-station-store-integration']",
      updatedAt: '2023-08-09T00:16:16.988281Z',
    },
    {
      id: 'f5013b89-fa14-4cb1-814f-df91f6321895',
      leadId: '867c92fd-6dec-41dc-b708-cf7ecb194d06',
      product: 'store',
      attributeId: '29ba99aa-7623-432d-bf9b-4541e329239c',
      attributeName: 'Opt-in Legal Base',
      attributeSlug: 'rdstation_optin_legal_base',
      value: 'True',
      updatedAt: '2023-08-09T00:16:16.771493Z',
    },
    {
      id: '61f00cba-6d13-46d3-9611-b5ec51edeeda',
      leadId: '867c92fd-6dec-41dc-b708-cf7ecb194d06',
      product: 'store',
      attributeId: 'b32fd866-c262-4770-8c8d-591943c3284f',
      attributeName: 'Lead First Conversion Source',
      attributeSlug: 'rdstation_first_conversion_source',
      value: 'signup-origin:site',
      updatedAt: '2023-08-09T00:16:16.563657Z',
    },
    {
      id: 'ad935bb4-25e2-457a-a999-cd2ea3b839ab',
      leadId: '867c92fd-6dec-41dc-b708-cf7ecb194d06',
      product: 'store',
      attributeId: '6b308c5d-bf11-468f-b58f-63104561b35f',
      attributeName: 'Last Conversion Date',
      attributeSlug: 'rdstation_last_conversion_date',
      value: '2023-06-16T09:51:50.938-03:00',
      updatedAt: '2023-08-09T00:16:16.325906Z',
    },
    {
      id: '73241464-4d8c-40e4-ad3e-c7cc1a3dd383',
      leadId: '867c92fd-6dec-41dc-b708-cf7ecb194d06',
      product: 'store',
      attributeId: '02983fe1-9c9c-4de7-bed4-60950f1f9023',
      attributeName: 'Lead Created Date',
      attributeSlug: 'rdstation_created_at',
      value: '2022-07-29T10:18:35.161-03:00',
      updatedAt: '2023-08-09T00:16:16.145153Z',
    },
    {
      id: 'a59d1fb9-3abd-4613-87cf-f37d7b7f24bc',
      leadId: '867c92fd-6dec-41dc-b708-cf7ecb194d06',
      product: 'store',
      attributeId: '5419c92b-e5ab-41e0-a7ad-d8aad5264963',
      attributeName: 'Lead Funnel Stage',
      attributeSlug: 'rdstation_lead_stage',
      value: 'Lead',
      updatedAt: '2023-08-09T00:16:15.935247Z',
    },
    {
      id: '45bafbbd-a78c-46fc-9c16-05d645b2d1dc',
      leadId: '867c92fd-6dec-41dc-b708-cf7ecb194d06',
      product: 'store',
      attributeId: '548f35ad-b456-48ca-97ca-a739a49d0ee7',
      attributeName: 'Lead Owner',
      attributeSlug: 'rdstation_lead_owner',
      value: 'roni.lopes@olist.com',
      updatedAt: '2023-08-09T00:16:15.702416Z',
    },
    {
      id: '2bda162e-2eea-473d-8efa-afcb1edb8a1e',
      leadId: '867c92fd-6dec-41dc-b708-cf7ecb194d06',
      product: 'store',
      attributeId: '3f1470f0-92b7-4d96-bb7d-e4650e0dfd67',
      attributeName: 'integrator',
      attributeSlug: 'integrator',
      value: 'tiny',
      updatedAt: '2022-08-03T13:24:45.663472Z',
    },
    {
      id: 'a202422b-6cf7-488c-9c1f-98d4e433e61a',
      leadId: '867c92fd-6dec-41dc-b708-cf7ecb194d06',
      product: 'store',
      attributeId: '749acac5-c73c-4b8c-9170-5ae39e94b587',
      attributeName: 'has_bank_account_associated_cnpj',
      attributeSlug: 'has_bank_account_associated_cnpj',
      value: true,
      updatedAt: '2022-08-01T16:47:50.678025Z',
    },
    {
      id: '42c7d70d-917c-4597-bdc8-a33eabbb0ec3',
      leadId: '867c92fd-6dec-41dc-b708-cf7ecb194d06',
      product: 'store',
      attributeId: '821bde0b-9eee-401e-b7d7-7eb244bd347e',
      attributeName: 'has_nfe_xml',
      attributeSlug: 'has_nfe_xml',
      value: true,
      updatedAt: '2022-08-01T16:47:50.678025Z',
    },
    {
      id: '6fc9ead6-1e81-4cb1-9b05-c4151eb0e1ee',
      leadId: '867c92fd-6dec-41dc-b708-cf7ecb194d06',
      product: 'store',
      attributeId: 'b7bf20ab-79b6-4412-9d52-ebbe47016182',
      attributeName: 'respect_correios_max_dimensions',
      attributeSlug: 'respect_correios_max_dimensions',
      value: true,
      updatedAt: '2022-08-01T16:47:50.678025Z',
    },
    {
      id: '16740aab-f9ac-42d1-9d09-752c210a09da',
      leadId: '867c92fd-6dec-41dc-b708-cf7ecb194d06',
      product: 'store',
      attributeId: '9bd85c23-a0df-4d40-8f91-49632ced4ccf',
      attributeName: 'pre_signup_url',
      attributeSlug: 'pre_signup_url',
      value: '',
      updatedAt: '2022-08-03T13:24:45.663472Z',
    },
    {
      id: 'a12ef9fd-84c2-4be2-9af6-aaff8c7909f2',
      leadId: '867c92fd-6dec-41dc-b708-cf7ecb194d06',
      product: 'store',
      attributeId: 'a9bfc955-08fb-4e3c-aea6-468fa61b7b25',
      attributeName: 'is_already_online_seller',
      attributeSlug: 'is_already_online_seller',
      value: true,
      updatedAt: '2022-08-03T13:24:45.663472Z',
    },
    {
      id: 'e15d088a-bb44-4aff-a5f0-9f1d798487a0',
      leadId: '867c92fd-6dec-41dc-b708-cf7ecb194d06',
      product: 'store',
      attributeId: '093de20b-1a92-4209-8283-d945f12647b1',
      attributeName: 'status',
      attributeSlug: 'status',
      value: 'account_created',
      updatedAt: '2022-08-03T13:24:45.663472Z',
    },
    {
      id: 'c12258b1-a369-4639-a31e-913ce39155cf',
      leadId: '867c92fd-6dec-41dc-b708-cf7ecb194d06',
      product: 'store',
      attributeId: 'b68e4119-2d89-4a8c-b5f2-179256002425',
      attributeName: 'terms_of_use_version',
      attributeSlug: 'terms_of_use_version',
      value: '5',
      updatedAt: '2022-08-03T13:24:45.663472Z',
    },
    {
      id: 'de97411b-5a82-4177-b7cb-961dd7c374f5',
      leadId: '867c92fd-6dec-41dc-b708-cf7ecb194d06',
      product: 'store',
      attributeId: 'f652ff09-3a1a-433f-a429-644c0f8ed7bd',
      attributeName: 'source',
      attributeSlug: 'source',
      value: 'site',
      updatedAt: '2022-08-03T13:24:45.663472Z',
    },
    {
      id: '7b5e9cf5-89ae-4a11-88a0-f30345a9db8a',
      leadId: '867c92fd-6dec-41dc-b708-cf7ecb194d06',
      product: 'store',
      attributeId: '063c77bf-b562-4836-8e2f-75550c329c7c',
      attributeName: 'signup_url',
      attributeSlug: 'signup_url',
      value: 'https://app.olist.com/setup/pre-signup',
      updatedAt: '2022-08-03T13:24:45.663472Z',
    },
  ],
};
